import curry from "../../../lib/core/functional/curry";

function toggleFolder(folders, folder) {
    const { slug } = folder;
    const index = folders.indexOf(slug);
    if (index >= 0) {
        return [...folders.slice(0, index), ...folders.slice(index + 1)];
    } else {
        return [...folders, slug];
    }
}

const renderModule = curry(function renderModule(preact, _context, deps, _altLoader) {
    const { Informer, raiseNotification } = deps;
    const { h, hooks } = preact;

    const { useCallback, useState, useEffect } = hooks;

    function Folder(props) {
        const { onClick, folder, selected, isTeam } = props;
        const { icon, slug, title, type } = folder;

        const _onClick = useCallback(
            function _onClick(event) {
                event.preventDefault();
                onClick(folder);
                return false;
            },
            [folder, onClick]
        );

        const nameSpace = `rm-folders-${isTeam ? "team-" : ""}folder`;

        return (
            <a
                href="javascript:;"
                onClick={_onClick}
                class={`${nameSpace} rm-folder-type-${type} ${
                    selected ? " rm-folders-folder-active" : ""
                }`}
                id={`${nameSpace}-${slug}`}
            >
                {icon && <img src={icon} class="rm-folders-folder-icon" />}
                <h3 class="rm-folders-folder-title">{title}</h3>
            </a>
        );
    }

    const folderMapper = curry(function folderMapper(onClick, selected, isTeam, folder) {
        const { slug } = folder;
        const isSelected = selected.includes(slug);
        return (
            <Folder
                key={slug}
                folder={folder}
                selected={isSelected}
                onClick={onClick}
                isTeam={isTeam}
            />
        );
    });

    function DialogBody(props) {
        const {
            folders,
            teamFolders,
            onFolderClick,
            onTeamFolderClick,
            selectedFolders,
            selectedTeamFolders,
        } = props;

        return (
            <div class="rm-folders-dialog-body">
                <div class="rm-folders-dialog-user-folders">
                    {folders.map(folderMapper(onFolderClick, selectedFolders, false))}
                </div>
                {teamFolders.length > 0 && (
                    <div class="rm-folders-dialog-team">
                        <h2>Team folders</h2>
                        <div class="rm-folders-dialog-team-folders">
                            {teamFolders.map(
                                folderMapper(onTeamFolderClick, selectedTeamFolders, true)
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    function Module(props) {
        const { isLoggedIn, getFolders, folders, teamFolders, addToFolders, success, disabled } =
            props;

        const [selectedFolders, setSelectedFolders] = useState([]);
        const [selectedTeamFolders, setSelectedTeamFolders] = useState([]);

        const [openDialog, setOpenDialog] = useState(false);

        useEffect(() => {
            if (success === true) {
                raiseNotification("Post saved", "success");
            } else if (success === false) {
                raiseNotification("There has been an error", "error");
            }
        }, [success]);

        const onClick = useCallback(
            function onClick() {
                if (disabled || !isLoggedIn) {
                    return;
                }
                getFolders();
                setOpenDialog(true);
            },
            [getFolders, disabled, isLoggedIn]
        );

        const onFolderClick = useCallback(
            function onFolderClick(folder) {
                setSelectedFolders(toggleFolder(selectedFolders, folder));
            },
            [selectedFolders]
        );
        const onTeamFolderClick = useCallback(
            function onTeamFolderClick(folder) {
                setSelectedTeamFolders(toggleFolder(selectedTeamFolders, folder));
            },
            [selectedTeamFolders]
        );

        const onPositiveClick = useCallback(
            function onPositiveClick() {
                setOpenDialog(false);
                addToFolders(selectedFolders, selectedTeamFolders);
                setSelectedFolders([]);
                setSelectedTeamFolders([]);
            },
            [selectedFolders, selectedTeamFolders, addToFolders]
        );

        const onNegativeClick = useCallback(function onNegativeClick() {
            setOpenDialog(false);
        }, []);

        useEffect(
            function dialogEffect() {
                if (!openDialog) {
                    return null;
                }

                Informer({
                    className: "rm-folder-dialog",
                    title: "Save this article",
                    body: (
                        <DialogBody
                            folders={folders}
                            teamFolders={teamFolders}
                            onFolderClick={onFolderClick}
                            onTeamFolderClick={onTeamFolderClick}
                            selectedFolders={selectedFolders}
                            selectedTeamFolders={selectedTeamFolders}
                        />
                    ),
                    possitiveAction: {
                        label: "Save",
                        callback: onPositiveClick,
                    },
                    negativeAction: {
                        label: "Cancel",
                        callback: onNegativeClick,
                    },
                });
            },
            [
                openDialog,
                folders,
                teamFolders,
                onFolderClick,
                onTeamFolderClick,
                onPositiveClick,
                onNegativeClick,
            ]
        );

        let buttonClass;
        if (success === true) {
            buttonClass = " rm-folders-success";
        } else if (success === false) {
            buttonClass = " rm-folders-error";
        } else {
            buttonClass = "";
        }

        return (
            <a
                onClick={onClick}
                class={`rm-folders-save-to-folder${buttonClass}${
                    disabled ? " rm-folders-disabled" : ""
                }`}
                href={isLoggedIn ? "javascript:;" : "/login"}
                ariaLabel={"Save post to folder"}
            >
                <i class="fa fa-folder"></i>
            </a>
        );
    }

    return Module;
});

export default function folderModule({ preact }) {
    return renderModule(preact);
}
